import type { AvailabilityPageProps } from "@b2bportal/core-hotels";
import { AvailabilityPage as CoreAvailabilityPage } from "@b2bportal/core-hotels";
import { MapAndFilterButtonGroup } from "@tenant/hotels";
import clsx from "clsx";
import styles from "./AvailabilityPage.module.scss";

export const AvailabilityPage = (props: AvailabilityPageProps) => {
  return (
    <CoreAvailabilityPage
      {...props}
      className={clsx(styles.AvailabilityPage, props.className)}
    >
      {!props.context.isLoading && (
        <MapAndFilterButtonGroup {...props.context.shopModeConfig} />
      )}
      {props.children}
    </CoreAvailabilityPage>
  );
};
